import { Anchor, Center, Stack, Text, Title } from '@mantine/core';
import { createRootRouteWithContext, Link, Outlet } from '@tanstack/react-router';
import type { AuthContextValue } from '../auth/types';

export interface RouterContext {
  auth: AuthContextValue;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
  notFoundComponent: NotFound,
});

function NotFound() {
  return (
    <Center h="100dvh">
      <Stack align="center" gap="xs">
        <Title order={2}>Page not found</Title>
        <Text c="dimmed">That screen doesn&apos;t exist.</Text>
        <Anchor component={Link} to="/">
          Back to home
        </Anchor>
      </Stack>
    </Center>
  );
}
